import React from 'react';
import { Button, Divider, Text, Menu } from '@mantine/core';
import { IconFilter, IconSquare, IconSquareCheck } from '@tabler/icons-react';
export default function Filter(_a) {
    var _b;
    var option = _a.option, onChoiceClick = _a.onChoiceClick;
    var selectedChoices = ((_b = option === null || option === void 0 ? void 0 : option.selectedChoices) === null || _b === void 0 ? void 0 : _b.length)
        ? option.selectedChoices.map(function (item) { return item.label; }).join(', ')
        : '';
    return (React.createElement(Menu, { withArrow: true },
        React.createElement(Menu.Target, null,
            React.createElement(Button, { leftSection: React.createElement(IconFilter, { style: { marginRight: -6 }, size: 12 }), variant: "outline", radius: "xl", size: "compact-xs", color: "gray" },
                option.label,
                selectedChoices !== '' && (React.createElement(React.Fragment, null,
                    React.createElement(Divider, { orientation: "vertical", m: 4 }),
                    React.createElement(Text, { c: "blue" }, selectedChoices))))),
        React.createElement(Menu.Dropdown, null, option.choices.map(function (item) { return (React.createElement(Menu.Item, { key: item.value, color: selectedChoices.includes(item.label) ? 'blue' : 'gray', onClick: function () { return onChoiceClick(item); }, leftSection: selectedChoices.includes(item.label) ? (React.createElement(IconSquareCheck, { size: 14 })) : (React.createElement(IconSquare, { size: 14 })) },
            React.createElement(Text, { size: 'xs' }, item.label))); }))));
}
